var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp3CalendarQuarter1SpringIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.c{fill:#fff;}.d{fill:#ffefe0;}.e,.g{fill:#89d9fb;}.f,.g,.h{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.h{fill:#e5e5e5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-calendar-quarter-1-spring-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 38.82,
    y: 13.75,
    width: 68.36,
    height: 57.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 38.82,
    y: 75,
    width: 68.36,
    height: 57.26
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 32.82,
    y: 69,
    width: 68.36,
    height: 47.83
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 67,
    y: 69,
    width: 34.18,
    height: 47.83
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 32.82,
    y: 116.83,
    width: 68.36,
    height: 9.42
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 32.82,
    y: 69,
    width: 68.36,
    height: 57.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 32.82,
    y: 7.74,
    width: 68.36,
    height: 57.26
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 39.47,
    y1: 62,
    x2: 39.47,
    y2: 72
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 47.33,
    y1: 62,
    x2: 47.33,
    y2: 72
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 55.2,
    y1: 62,
    x2: 55.2,
    y2: 72
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 63.07,
    y1: 62,
    x2: 63.07,
    y2: 72
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 70.93,
    y1: 62,
    x2: 70.93,
    y2: 72
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 78.8,
    y1: 62,
    x2: 78.8,
    y2: 72
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 86.67,
    y1: 62,
    x2: 86.67,
    y2: 72
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 94.53,
    y1: 62,
    x2: 94.53,
    y2: 72
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 32.82,
    y1: 116.83,
    x2: 101.18,
    y2: 116.83
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 39.47,
    y1: 81.16,
    x2: 73.88,
    y2: 81.16
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 39.47,
    y1: 89,
    x2: 73.88,
    y2: 89
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 39.47,
    y1: 96.84,
    x2: 73.88,
    y2: 96.84
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 39.47,
    y1: 104.67,
    x2: 73.88,
    y2: 104.67
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 80.77,
    y1: 81.16,
    x2: 94.53,
    y2: 81.16
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 80.77,
    y1: 86.64,
    x2: 94.53,
    y2: 86.64
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 80.77,
    y1: 99.19,
    x2: 94.53,
    y2: 99.19
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 80.77,
    y1: 104.67,
    x2: 94.53,
    y2: 104.67
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 67,
    cy: 14.82,
    r: 2.36
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp3CalendarQuarter1SpringIcon);
export default __webpack_public_path__ + "static/media/CP3-calendar-quarter-1-spring-icon.c729e28aae956c000aa817ef351193d5.svg";
export { ForwardRef as ReactComponent };